export default __webpack_public_path__ + "static/190-e19162d2fe39e5d7ff0fec072dad170b.jpg";